module.exports = __webpack_public_path__ + "static/media/059-Delta - SOCO Kitchen.9e62a3f1.png";